import { CiviliteEnum } from '@graphql/generated';

export class CiviliteMapper {
  public static toGraphql(civilite?: 'monsieur' | 'madame'): CiviliteEnum | undefined {
    const mapping: Record<'monsieur' | 'madame', CiviliteEnum> = {
      monsieur: CiviliteEnum.Monsieur,
      madame: CiviliteEnum.Madame,
    };
    return civilite ? mapping[civilite] : undefined;
  }

  public static fromGraphQl(civilite?: string | null): 'monsieur' | 'madame' | undefined {
    const mapping: Record<CiviliteEnum, 'monsieur' | 'madame'> = {
      [CiviliteEnum.Monsieur]: 'monsieur',
      [CiviliteEnum.Madame]: 'madame',
    };
    return civilite ? mapping[civilite as CiviliteEnum] : undefined;
  }
}
